if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.isPreview = this.dataset.preview === 'true';

        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        this.init();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      init() {
        this.mainSubmitButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        this.stickyButton = this.querySelector(`#StickySubmitButton-${this.sectionId}`);
        this.priceContainer = this.querySelector(`#StickyPrice-${this.sectionId}`);
        this.imageContainer = this.querySelector(`#StickyProductImage-${this.sectionId}`);
        this.mainQuantityInput = document.querySelector(`#Quantity-${this.sectionId}`);
        this.stickyQuantityInput = this.querySelector(`#StickyQuantity-${this.sectionId}`);

        if (!this.mainSubmitButton || !this.stickyButton) {
          if ((this.retryCount || 0) < 10) {
            this.retryCount = (this.retryCount || 0) + 1;
            requestAnimationFrame(() => this.init());
          }
          return;
        }

        this.setup();
      }

      setup() {
        if (this.isInitialized) return;
        this.isInitialized = true;

        if (this.isPreview) {
          this.toggleBar(true);
        } else {
          this.setupVisibilityObserver();
          this.checkVisibility();
        }

        this.stickyButton.addEventListener('click', this.onStickyClick.bind(this));
        this.setupQuantitySync();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            this.updateStickyBar(event.data);
          });
        }
      }

      cleanup() {
        if (this.observer) this.observer.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll, { passive: true });
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        document.body.classList.remove('sticky-atc-visible');
      }

      setupVisibilityObserver() {
        this.observer = new IntersectionObserver(
          () => this.checkVisibility(),
          { threshold: 0, rootMargin: '0px' }
        );
        this.observer.observe(this.mainSubmitButton);

        this.onScroll = () => this.checkVisibility();
        this.onResize = () => this.checkVisibility();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
      }

      checkVisibility() {
        if (!this.mainSubmitButton || this.isPreview) return;

        const rect = this.mainSubmitButton.getBoundingClientRect();
        const show = rect.bottom <= 0 || rect.top >= window.innerHeight;
        this.toggleBar(show);
      }

      toggleBar(show) {
        if (show) {
          this.removeAttribute('hidden');
          requestAnimationFrame(() => this.classList.add('is-visible'));
          document.body.classList.add('sticky-atc-visible');
        } else {
          this.classList.remove('is-visible');
          document.body.classList.remove('sticky-atc-visible');
          this.setAttribute('hidden', '');
        }
      }

      setupQuantitySync() {
        if (!this.mainQuantityInput || !this.stickyQuantityInput) return;

        this.syncQuantity(this.mainQuantityInput, this.stickyQuantityInput);

        this.mainQuantityInput.addEventListener('change', () => {
          this.syncQuantity(this.mainQuantityInput, this.stickyQuantityInput);
        });

        this.stickyQuantityInput.addEventListener('change', () => {
          this.syncQuantity(this.stickyQuantityInput, this.mainQuantityInput);
        });
      }

      syncQuantity(source, target) {
        if (!source || !target || source.value === target.value) return;
        target.value = source.value;
      }

      onStickyClick() {
        if (this.mainSubmitButton.disabled) return;

        if (this.mainQuantityInput && this.stickyQuantityInput) {
          this.mainQuantityInput.value = this.stickyQuantityInput.value;
        }

        this.mainSubmitButton.click();
      }

      updateStickyBar({ html, variant }) {
        const newPrice = html.getElementById(`price-${this.sectionId}`);
        if (newPrice && this.priceContainer) {
          this.priceContainer.innerHTML = newPrice.innerHTML;
        }

        const newMainButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (newMainButton) {
          const isDisabled = newMainButton.hasAttribute('disabled');
          this.mainSubmitButton.disabled = isDisabled;
          this.stickyButton.disabled = isDisabled;
          const label = newMainButton.querySelector('span')?.textContent?.trim();
          if (label) this.stickyButton.querySelector('span').textContent = label;
        }

        const newQuantity = html.getElementById(`Quantity-${this.sectionId}`);
        if (newQuantity && this.stickyQuantityInput) {
          ['min', 'max', 'step', 'value', 'data-min', 'data-max', 'data-cart-quantity'].forEach((attr) => {
            if (newQuantity.hasAttribute(attr)) {
              this.stickyQuantityInput.setAttribute(attr, newQuantity.getAttribute(attr));
            } else {
              this.stickyQuantityInput.removeAttribute(attr);
            }
          });
          this.stickyQuantityInput.value = newQuantity.value;
        }

        if (variant?.featured_media?.preview_image?.src && this.imageContainer) {
          const img = this.imageContainer.querySelector('img');
          if (img) {
            img.src = variant.featured_media.preview_image.src;
            img.srcset = '';
          }
        }
      }
    }
  );
}
